export const COOKIE_CATEGORIES = {
  necessary: {
    name: "Necessary",
    description:
      "Essential cookies enable core functionality. The website cannot function properly without these cookies.",
  },
  preferences: {
    name: "Preferences",
    description:
      "Preference cookies enable the website to remember information that changes the way the website behaves or looks.",
  },
  statistics: {
    name: "Statistics",
    description:
      "Statistic cookies help us understand how visitors interact with our website by collecting anonymous information.",
  },
  marketing: {
    name: "Marketing",
    description:
      "Marketing cookies would allow us to provide you with personalized promotional content.",
  },
};

export const isCategoryAllowed = (category) => {
  try {
    const consent = JSON.parse(localStorage.getItem("cookieConsent"));
    return consent && consent[category] === true;
  } catch (e) {
    return false;
  }
};

export const getConsentSettings = () => {
  try {
    return JSON.parse(localStorage.getItem("cookieConsent")) || null;
  } catch (e) {
    return null;
  }
};

export const applyCookieConsent = () => {
  const consent = getConsentSettings();
  if (!consent) return;

  console.log("Applying cookie consent settings:", consent);
};

export const initializeGoogleAnalytics = () => {
  console.log("Google Analytics would be initialized if we had an ID");
};

export const initializeFacebookPixel = () => {
  console.log("Facebook Pixel would be initialized if we had an ID");
};
